var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65621 12.4728L4.66065 14.3305C4.34916 14.5237 3.94102 14.4246 3.74904 14.1093C3.65527 13.9553 3.62695 13.7697 3.67047 13.5947L4.13 11.747C4.29587 11.08 4.74599 10.5224 5.35903 10.2246L8.62823 8.63623C8.78065 8.56219 8.84444 8.3771 8.7708 8.2229C8.71109 8.09798 8.57674 8.02807 8.44167 8.05173L4.79962 8.68924C4.05928 8.81887 3.29914 8.61211 2.72167 8.12416L1.56795 7.14924C1.28687 6.91172 1.24891 6.48942 1.48317 6.206C1.5971 6.06814 1.76124 5.98256 1.93862 5.96854L5.45483 5.69037C5.70324 5.67072 5.91935 5.5118 6.01411 5.2791L7.36198 1.96906C7.5011 1.62742 7.88821 1.4652 8.22665 1.60673C8.3891 1.67468 8.51843 1.80501 8.58615 1.96906L9.95182 5.2791C10.0478 5.5118 10.2648 5.67072 10.5133 5.69037L14.0504 5.97006C14.4152 5.99891 14.6886 6.32116 14.661 6.68983C14.6478 6.86717 14.5652 7.03171 14.4316 7.14711L11.7409 9.47083C11.5514 9.63438 11.4693 9.8919 11.5283 10.137L12.3668 13.6182C12.4535 13.9777 12.2354 14.3392 11.88 14.4258C11.7091 14.4675 11.5288 14.4386 11.3786 14.3458L8.3484 12.4728C8.13567 12.3413 7.86825 12.3413 7.65621 12.4728Z",
    fill: "url(#paint0_linear_2088_1593)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2088_1593",
    x1: 7.98258,
    y1: 1.55557,
    x2: 7.98258,
    y2: 14.4444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F79600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB802"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.dffc6c45919c7cca293c3a27e8fbcf0b.svg";
export { ForwardRef as ReactComponent };